(() => {
  const variants = {
    cleanser: 48149636088106,
    cream: 47670161965354,
    toner: 48420446961962,
    kit: 48420459839786
  };
  const bannerId = 'hongo-complete-routine-offer';
  let busy = false;
  let timer;
  let needsReview = false;
  const root = window.Shopify?.routes?.root || '/';

  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => {
    if (!r.ok) throw new Error('Unable to read cart');
    return r.json();
  });

  const quantityFor = (cart, id) => cart.items
    .filter(item => Number(item.variant_id) === id)
    .reduce((sum, item) => sum + item.quantity, 0);

  const eligible = cart =>
    quantityFor(cart, variants.cleanser) > 0 &&
    quantityFor(cart, variants.cream) > 0 &&
    quantityFor(cart, variants.toner) > 0 &&
    quantityFor(cart, variants.kit) === 0;

  const removeBanner = () => document.getElementById(bannerId)?.remove();

  const showBanner = cart => {
    if (busy || needsReview) return;
    if (!eligible(cart) || document.getElementById(bannerId) || sessionStorage.getItem('hongo-routine-dismissed') === '1') {
      if (!eligible(cart)) removeBanner();
      return;
    }

    if (busy || needsReview) return;
    const el = document.createElement('aside');
    el.id = bannerId;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Simple Skin Ritual offer');
    el.innerHTML = `
      <div class="hongo-routine-copy">
        <strong>You’ve created the complete Simple Skin Ritual.</strong>
        <span>Switch to the set and save $9.</span>
      </div>
      <div class="hongo-routine-actions">
        <button type="button" class="button hongo-routine-switch">Switch to the $84 set</button>
        <button type="button" class="hongo-routine-dismiss" aria-label="Keep products separate">Keep separate</button>
      </div>`;

    const style = document.createElement('style');
    style.textContent = `
      #${bannerId}{position:fixed;z-index:10000;left:50%;bottom:2rem;transform:translateX(-50%);width:min(92vw,72rem);display:flex;align-items:center;justify-content:space-between;gap:2rem;padding:1.6rem 2rem;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border:1px solid rgba(var(--color-foreground),.18);border-radius:var(--popup-corner-radius,8px);box-shadow:0 8px 28px rgba(0,0,0,.18)}
      #${bannerId} .hongo-routine-copy{display:flex;flex-direction:column;gap:.25rem}
      #${bannerId} .hongo-routine-copy strong{font-size:1.6rem}
      #${bannerId} .hongo-routine-actions{display:flex;align-items:center;gap:1.2rem;flex-shrink:0}
      #${bannerId} .hongo-routine-dismiss{border:0;background:transparent;color:inherit;text-decoration:underline;cursor:pointer;padding:.8rem}
      #${bannerId}[aria-busy="true"]{opacity:.7;pointer-events:none}
      @media(max-width:749px){#${bannerId}{bottom:1rem;align-items:stretch;flex-direction:column;gap:1.2rem}#${bannerId} .hongo-routine-actions{flex-direction:column;align-items:stretch}#${bannerId} .button{width:100%}}
    `;
    el.appendChild(style);
    document.body.appendChild(el);

    el.querySelector('.hongo-routine-dismiss').addEventListener('click', () => {
      sessionStorage.setItem('hongo-routine-dismissed', '1');
      removeBanner();
    });

    el.querySelector('.hongo-routine-switch').addEventListener('click', async () => {
      if (needsReview) {
        window.location.assign(root + 'cart');
        return;
      }
      if (busy) return;
      busy = true;
      el.setAttribute('aria-busy', 'true');
      el.querySelector('.hongo-routine-switch').textContent = 'Switching…';
      try {
        const latest = await getCart();
        if (!eligible(latest)) {
          removeBanner();
          return;
        }
        const originals = [variants.cleanser, variants.cream, variants.toner].map(id =>
          latest.items.find(item => Number(item.variant_id) === id &&
            !item.parent_relationship && !item.selling_plan_allocation &&
            !item.item_components?.length && item.quantity > 0)
        );
        if (originals.some(item => !item || Object.keys(item.properties || {}).length)) {
          throw new Error('Please review customized products in your cart');
        }

        const added = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variants.kit, quantity: 1 }] })
        });
        if (!added.ok) throw new Error('Unable to add set');

        const afterAdd = await getCart();
        const remaining = originals.map(original => afterAdd.items.find(item =>
          item.key === original.key && item.quantity === original.quantity &&
          !item.parent_relationship && !item.item_components?.length
        ));
        if (remaining.some(item => !item) || quantityFor(afterAdd, variants.kit) < 1) {
          throw new Error('Please review your updated cart');
        }
        const updates = Object.fromEntries(remaining.map(item => [item.key, item.quantity - 1]));
        const changed = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!changed.ok) throw new Error('Unable to update cart');
        window.location.assign(root + 'cart');
      } catch (error) {
        needsReview = true;
        el.setAttribute('aria-busy', 'false');
        el.querySelector('.hongo-routine-switch').textContent = 'Review cart';
        const message = document.createElement('small');
        message.className = 'hongo-routine-error';
        message.setAttribute('role', 'alert');
        message.textContent = 'We could not confirm the switch. Please review your cart quantities before checking out.';
        el.querySelector('.hongo-routine-copy').appendChild(message);
      } finally {
        busy = false;
        el.setAttribute('aria-busy', 'false');
      }
    });
  };

  const check = () => {
    clearTimeout(timer);
    timer = setTimeout(() => getCart().then(showBanner).catch(() => {}), 350);
  };

  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('click', event => {
    if (event.target.closest('button, a, input')) check();
  });
  document.addEventListener('submit', check);
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
})();